import React from 'react'
import NavLink from '../nav-link'
import useViewport from '../../../hooks/use-viewport'

const NavIconLink = ({
    icon,
    children,
    size = 25,
    title,
    ...props
}) => {
    const { isMobile } = useViewport()
    const Icon = icon
    return (
        <NavLink {...props}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    fontSize: isMobile ? '0.6em' : '1em'
                }}
                title={title}
            >
                <Icon size={isMobile ? size / 2 : size} /> 
                {children}
            </div>
        </NavLink>
    )
}

export default NavIconLink